import React, { useEffect, useState } from 'react';
import { Compass, ShieldCheck, Camera, Leaf } from 'lucide-react';
import { experiences, stats as mockStats } from '../mock';
import { publicApi } from '../lib/api';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_EXPERIENCE_IMAGE = "https://images.unsplash.com/photo-1702236315790-0ffd668c5784?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";

const iconMap = { Compass, ShieldCheck, Camera, Leaf };

const Experience = () => {
  const [stats, setStats] = useState(mockStats);
  const [experienceImage, setExperienceImage] = useState(DEFAULT_EXPERIENCE_IMAGE);

  useEffect(() => {
    publicApi.getStats().then((s) => {
      setStats([
        { value: `${s.passengers.toLocaleString('fr-FR')}+`, label: 'Passagers satisfaits' },
        { value: s.average_rating.toString(), label: 'Note moyenne' },
        { value: s.max_per_boat.toString(), label: 'Places par barque' },
        { value: s.days_per_year.toString(), label: 'Jours par an' }
      ]);
    }).catch(() => {});
    axios.get(`${API_URL}/api/settings`).then((r) => {
      if (r.data?.experience_image) setExperienceImage(r.data.experience_image);
    }).catch(() => {});
  }, []);
  return (
    <section id="experience" className="bg-white py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left - stats & image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5] shadow-xl">
              <img
                src={experienceImage}
                alt="Balade lagunaire"
                className="w-full h-full object-cover"
                data-testid="experience-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent"></div>
            </div>

            {/* Floating stats card */}
            <div className="absolute -bottom-8 -right-4 md:-right-8 bg-white rounded-2xl shadow-2xl p-6 border border-slate-100 max-w-xs">
              <div className="grid grid-cols-2 gap-4">
                {stats.map((s, i) => (
                  <div key={i}>
                    <div className="text-2xl font-bold text-[#E89534]">{s.value}</div>
                    <div className="text-xs text-slate-500 mt-1">{s.label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Decorative diamond */}
            <div className="absolute -top-4 -left-4 w-16 h-16 rotate-45 bg-[#F4A340]/20 rounded-md"></div>
          </div>

          {/* Right */}
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#F4A340]/10 text-[#E89534] text-xs font-semibold tracking-widest uppercase mb-4">
              Pourquoi nous
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 leading-tight mb-6">
              L'expérience lagunaire <span className="text-[#E89534]">authentique</span>
            </h2>
            <p className="text-slate-600 leading-relaxed text-lg mb-10">
              Depuis les rives de Cotonou jusqu'aux villages sur pilotis de Ganvié,
              nous vous emmenons à la découverte d'un patrimoine vivant, avec le confort
              et la sécurité que vous méritez.
            </p>

            <div className="grid sm:grid-cols-2 gap-5">
              {experiences.map((exp) => {
                const Icon = iconMap[exp.icon];
                return (
                  <div
                    key={exp.id}
                    className="group p-5 rounded-2xl border border-slate-200 hover:border-[#F4A340] hover:shadow-md transition-all duration-300 bg-white"
                  >
                    <div className="w-11 h-11 rounded-xl bg-[#F4A340]/10 group-hover:bg-[#F4A340] flex items-center justify-center mb-4 transition-colors">
                      <Icon className="w-5 h-5 text-[#E89534] group-hover:text-white transition-colors" />
                    </div>
                    <h3 className="font-bold text-slate-900 mb-1">{exp.title}</h3>
                    <p className="text-sm text-slate-600 leading-relaxed">{exp.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
